export * from "fp-ts/lib/These";

import * as RNA from "fp-ts/lib/ReadonlyNonEmptyArray";
import * as Th from "fp-ts/lib/These";

export const ofRNA = Th.bimap(RNA.of, RNA.of);
